export default "__VITE_ASSET__CMcMZKRW__"